module.exports = __webpack_public_path__ + "img/login_title.72edf899.png";